import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { useAuth } from '../context/AuthContext';
import { baseUrl, getValidAccessToken, fetchWordById } from "../shared";
import Logo from "../logo512.png";
import { useTranslation } from "react-i18next";
import "../i18n";
import { AuthContext } from "../context/AuthContext";

import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";

// Claude: UAT feedback — "Only administrators and approvers should be able to change the status
// Claude: of a word to accepted or rejected... Flagged should be available only to
// Claude: administrators, approvers and editors." Matches _status_change_allowed in views.py,
// Claude: which enforces this server-side too — this just keeps the dropdown from offering
// Claude: choices that would 403 on submit. The word's own current status is always included
// Claude: separately below even if it isn't one of these (e.g. an editor viewing an ACCEPTED
// Claude: term) so the field can still show/keep it, just not switch to a different value the
// Claude: role isn't allowed to set.
const STATUS_OPTIONS_BY_ROLE = {
  administrator: ["PND", "ACC", "REJ", "FLG"],
  approver: ["PND", "ACC", "REJ", "FLG"],
  editor: ["PND", "FLG"],
};
const STATUS_LABELS = { PND: "pending", ACC: "accepted", REJ: "rejected", FLG: "flagged" };

function UpdateWord({ isLoggedIn, onLogout }) {
  const { auth } = useContext(AuthContext);

  const { t } = useTranslation();
  const { id } = useParams();
  //   const { auth } = useAuth();
  const [phrase, setPhrase] = useState(null);
  const [word, setWord] = useState("");
  const [definition, setDefinition] = useState("");
  const [field, setField] = useState("");
  const [school, setSchool] = useState("");
  const [attribution, setAttribution] = useState("");
  const [status, setStatus] = useState("");
  const [language, setLanguage] = useState("");
  const [example, setExample] = useState("");
  // Claude: notes field (alpha-tester request). null means "not loaded" — the backend only returns
  // Claude: notes to an authenticated request, so if they didn't come back the field is hidden and
  // Claude: left out of the save entirely, rather than overwriting the real note with a blank.
  const [notes, setNotes] = useState(null);
  const [editor, setEditor] = useState("");
  const [date_edited, setDate_edited] = useState("");
  const [date_accepted, setDate_accepted] = useState("");
  const [pos, setPos] = useState("");
  const [synonyms, setSynonyms] = useState("");

  const date = new Date(); // Current date and time
  const isoDate = date.toISOString(); // Convert to ISO 8601 format
  // const [interfaceLanguage, setInterfaceLanguage] = useState("Eng");

//  const isAccessTokenExpired = (token) => {
//    if (!token) return true;  // If no token, treat as expired
 
//    const tokenParts = JSON.parse(atob(token.split('.')[1]));
//    const now = Math.floor(Date.now() / 1000);
//    console.log("tokenoets:",tokenParts,now,tokenParts.exp < now) 
//    return tokenParts.exp < now;  // Check if the token's expiration time is in the past
//  };
      
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPhrase = async () => {
      // Claude: authenticated fetch so this entry's notes are included (see fetchWordById).
      const response = await fetchWordById(id);
      const data = await response.json();
      console.log("rou ontvangs:",data)
      setPhrase(data["terms!"]);
      setWord(data["terms!"][0].word);
      setDefinition(data["terms!"][0].definition);
      // Claude: bugfix — the existing example was never loaded into the form, so saving any edit
      // Claude: sent example: "" and silently blanked the term's Example.
      setExample(data["terms!"][0].example || "");
      setField(data["terms!"][0].field);
      setSchool(data["terms!"][0].school);
      setAttribution(data["terms!"][0].attribution);
      setStatus(data["terms!"][0].status);
      setLanguage(data["terms!"][0].language);
      setPos(data["terms!"][0].pos);
      setSynonyms(data["terms!"][0].synonyms);
      setEditor(data["terms!"][0].editor);
      setDate_accepted(data["terms!"][0].date_accepted);
      setDate_edited(data["terms!"][0].date_edited);
      if ("notes" in data["terms!"][0]) {
        setNotes(data["terms!"][0].notes || "");
      }
    };
    fetchPhrase();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDate_edited(isoDate);
    console.log(
      JSON.stringify({ pos, word, definition, example, editor, date_edited })
    );
    console.log("Wat gestuur word: ",JSON.stringify({
          word,
          definition,
          example,
          field,
          pos,
          synonyms,
          school,
          language,
          attribution,
          status,
          editor,
          date_accepted,
          date_edited,
        }))
    try {
       await getValidAccessToken(); // Get valid token

      //  console.log("AccessTokenvalid: ",isAccessTokenExpired(localStorage.getItem("accessToken")))
      await fetch(baseUrl + `v1/updateword/${id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          word,
          definition,
          example,
          field,
          pos,
          synonyms,
          school,
          language,
          attribution,
          status,
          editor,
          date_accepted,
          date_edited,
          // Claude: only sent when the notes were actually loaded (see the notes state above).
          ...(notes !== null ? { notes } : {}),
        }),
      });
      navigate(`/phrase/${id}`);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!phrase) return <div>Loading...</div>;

  const roleAllowedStatusCodes = STATUS_OPTIONS_BY_ROLE[auth.userRole] || ["PND"];
  const selectableStatusCodes = roleAllowedStatusCodes.includes(status)
    ? roleAllowedStatusCodes
    : [status, ...roleAllowedStatusCodes];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* <Navbar /> */}
      {/* {auth.userRole === "editor" && <Navbar />}
      {auth.userRole !== "editor" && <Navbaranonuser />} */}
      {localStorage.setItem("bladsy", "UpdateWord")}
      {localStorage.getItem("userName") === null && <Navbaranonuser />}
      {localStorage.getItem("userName") != null && <Navbar />}

      <div className="flex flex-col justify-center items-center p-3">
        <h2 className="text-3xl font-bold mb-2">{t("update")}</h2>
        <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-6 justify-center">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("word")}:</strong>
              </label>
              <input
                type="text"
                value={word}
                onChange={(e) => setWord(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("pos")}:</strong>
              </label>
              <select
                value={pos}
                onChange={(e) => {
                  setPos(e.target.value);
                }}
                className="border p-2 w-full"
              >
                <option value="Unknown">{t("unknown")}</option>
                <option value="Noun">{t("noun")}</option>
                <option value="Verb">{t("verb")}</option>
                <option value="Adjective">{t("adjective")}</option>
                <option value="Pronoun">{t("pronoun")}</option>
                <option value="Adverb">{t("adverb")}</option>
                <option value="Preposition">{t("preposition")}</option>
                <option value="Conjunction">{t("conjunction")}</option>
                <option value="Article">{t("article")}</option>
                <option value="Interjection">{t("interjection")}</option>
              </select>
              </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("definition")}:</strong>
              </label>
              <input
                type="text"
                value={definition}
                onChange={(e) => setDefinition(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("example")}:</strong>
              </label>
              <input
                type="text"
                value={example}
                onChange={(e) => setExample(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            {/* Claude: notes field (alpha-tester request) — free-form, multi-line, optional. */}
            {notes !== null && (
              <div className="mb-4">
              <label htmlFor="update-notes" className="block text-gray-700">
                <strong>{t("notes")}:</strong>
              </label>
              <textarea
                id="update-notes"
                rows={3}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                aria-describedby="update-notes-hint"
                className="border p-2 w-full"
              />
              <p id="update-notes-hint" className="text-sm text-gray-500">{t("notes_hint")}</p>
            </div>
            )}
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("context")}:</strong>
              </label>
              <input
                type="text"
                value={field}
                onChange={(e) => setField(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("school")}:</strong>
              </label>
              <input
                type="text"
                value={school}
                onChange={(e) => setSchool(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("attribution")}:</strong>
              </label>
              <input
                type="text"
                value={attribution}
                onChange={(e) => setAttribution(e.target.value)}
                className="border p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("status")}:</strong>
              </label>
              <select
                id="status"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  // console.log("authusername", auth.userName);
                  setEditor(localStorage.getItem("userName"));
                  setDate_accepted(isoDate);
                }}
                className="w-full p-2 border rounded-lg"
              >
                {selectableStatusCodes.map((code) => (
                  <option key={code} value={code}>{t(STATUS_LABELS[code])}</option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">
                <strong>{t("language")}:</strong>
              </label>
              <select
                id="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="w-full p-2 border rounded-lg"
              >
                <option value="Eng">English</option>
                <option value="Afr">Afrikaans</option>
                <option value="Zul">isiZulu</option>
                <option value="Ses">Sesotho</option>
                <option value="Sep">Sepedi</option>
                <option value="Set">Setswana</option>
                <option value="Xit">Xitsonga</option>
                <option value="Sis">siSwati</option>
                <option value="Nde">isiNdebele</option>
                <option value="Xho">isiXhosa</option>
                <option value="Tsh">Tshivenḓa</option>
                <option value="Por">Portuguese</option>
                <option value="Fre">French</option>
              </select>
            </div>
            <button
              type="submit"
              className="w-full bg-cyan-700 text-white py-2 px-4 rounded-lg hover:bg-cyan-800"
            >
              {t("update")}
            </button>
            <button
              type="reset"
              onClick={(e) => {
                // setWord(word);
                // setDefinition(definition);
                // setExample(example);
                window.history.back();
              }}
              className="w-1/2 mt-6 bg-rose-700 text-white py-2 px-4 rounded-lg hover:bg-rose-800"
            >
              {t("cancel")}
            </button>
          </form>
        </div>
        <div className="flex flex-col justify-center items-center p-4">
          <a href="/" className="inline-block">
            <img src={Logo} alt="Logo" width="100" height="100" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default UpdateWord;
